import { AddToCartProps } from '@teko/ecommerce';
import { CartContextStateV2 } from 'contexts';
import { BannerEntity } from './entities';
import {
  DiscoveryPromotion,
  ProductDetailProductGroupVariant,
  ProductDetailProductGroupVariantAttrValue,
  ProductDetailSeoInfo,
  ProductStatus,
  ProductInfoCategory,
  ProductDetailAttributeGroup,
  ProductDetailAttributeSet,
  ProductProvider,
  Brand,
  DiscoverySellerProvider,
  DiscoveryProduct,
  BenefitItems,
  BenefitVoucher,
  ProductOptions,
  SearchProductPagination,
  DiscoveryAttribute,
} from '@teko/discovery';
import { CalculatedPrice, CalculatePricePromotion } from '@teko/cart/v2';

export interface ServerProduct {
  products?: DiscoveryProduct[];
  pagination?: SearchProductPagination;
}

export interface ProductResponse {
  product: DiscoveryProduct;
  sameBrandProducts: DiscoveryProduct[];
  priceAndPromotions?: CalculatedPrice;
}

export interface ConfigurationOption {
  value: string;
  optionId: number;
  thumbnailUrl: string;
  visible: boolean;
  selected: boolean;
}

export interface ConvertedConfiguration {
  id: number;
  code: string;
  name: string;
  optionType: string;
  options: ConfigurationOption[];
}

export interface ConvertedProduct {
  sku: string;
  sellerSku: string;
  tags?: string[];
  flashSale?: {
    total: number;
    used: number;
    endAt: string;
    type: string;
  };
  status?: ProductStatus;
  images: {
    src: string;
    alt: string;
  }[];
  title: {
    name: string;
    status?: {
      value: string;
      color: string;
    };
  };
  name: string;
  displayName: string;
  price: {
    price?: string | number;
    supplierRetailPrice?: string | number;
    listedPrice?: string | number;
    terminalPrice?: string | number;
    sellPrice?: string | number;
    discount?: string | number;
    priceWithoutSelectionPromotion?: number;
    discountAmount?: string | number;
    promotions?: CalculatePricePromotion[];
  };
  seoInfo?: ProductDetailSeoInfo;
  brand: Brand;
  categories: ProductInfoCategory[];
  masterCategories: ProductInfoCategory[];
  attributeGroups?: ProductDetailAttributeGroup[];
  attributes?: DiscoveryAttribute[];
  needManageStock: boolean;
  totalAvailable?: number;
  attributeSet?: ProductDetailAttributeSet;
  provider?: ProductProvider;
  seller?: DiscoverySellerProvider;
  selected?: ProductDetailProductGroupVariantAttrValue[];
  orderCouponPromotions?: DiscoveryPromotion[];
  partOrderPromotions?: DiscoveryPromotion[];
  defaultPromotions?: DiscoveryPromotion[];
  selectionPromotions?: DiscoveryPromotion[];
  productGroup?: {
    id: number;
    name: string;
    visible: string;
    variants?: ProductDetailProductGroupVariant[];
    configurations?: ConvertedConfiguration[];
  };
  isBundle?: boolean;
  addToCart?: AddToCartProps;
  save?: number;
  saveWithoutSelectionPromotion?: number;
  selectPromotionId?: number;
  isAlcoholicCategory?: boolean;
  uomName?: string;
  uomRatio?: number;
  uomCode?: string;
  barcode?: string;

  clearanceTypeDescription?: string;
  productOptions?: ProductOptions;
}

export interface OptionConvertProductCart {
  frames?: BannerEntity[];
  cartV2?: CartContextStateV2;
  showUom?: boolean;
  contactLink?: string;
}

export interface ComboItem {
  type: 'autogen' | 'dynamic';
  supplierRetailPrice: number;
  latestPrice: number;
  promotion?: DiscoveryPromotion;
  promotionId?: number;
  items: {
    quantity: number;
    product: DiscoveryProduct;
  }[];
}

export interface ComboProduct {
  sku: string;
  image: string;
  name: string;
  selectedVariant: string[];
  quantity: number;
  supplierRetailPrice: number;
  latestPrice: number;
  totalAvailable: number | null;
  selectionPromotionId?: number;
  selectionPromotion: DiscoveryPromotion;
  selectionPromotions: DiscoveryPromotion[];
  defaultPromotions: DiscoveryPromotion[];
  allowSelectPromotion?: boolean;
  gifts: BenefitItems[];
  vouchers: BenefitVoucher[];
  saveWithoutSelectionPromotion?: number;
  productConfigurations?: ConvertedConfiguration[];
  priceWithoutSelectionPromotion?: number;
  uomName?: string;
}

export enum PromotionApplyOnEnum {
  product = 'product',
  partOrder = 'part-order',
}

export interface IDataConvertLinkProduct {
  name: string;
  sku: string;
}
export interface ILinkProduct {
  as: string;
  href: {
    pathname: string;
    query: {
      sku: string;
    };
  };
  passHref: boolean;
}
